"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// exposed to UI to submit data to app sdk -- replacing state manager
var app_sdk_1 = require("./app-sdk");
/*** Event actions types. */
var LoginEventActions;
(function (LoginEventActions) {
    LoginEventActions["PAGE_LOAD"] = "pageLoad";
    LoginEventActions["LINK_CLICK"] = "linkClick";
    LoginEventActions["SYSTEM_EVENT"] = "systemEvent";
    LoginEventActions["FORM_RESPONSE"] = "formResponse";
    LoginEventActions["FORM_SUBMIT"] = "formSubmit";
    LoginEventActions["IMPRESSION"] = "impression";
    LoginEventActions["MARKETING"] = "marketing";
})(LoginEventActions = exports.LoginEventActions || (exports.LoginEventActions = {}));
var LoginAppSDKManager = /** @class */ (function () {
    function LoginAppSDKManager() {
    }
    LoginAppSDKManager.reportEvent = function (AppDTMEvent) {
        try {
            var updatedAnalyticsEvent = {
                eventAction: AppDTMEvent.eventAction,
                eventCode: AppDTMEvent.eventCode,
                additionaldata: AppDTMEvent.additionaldata,
                datatransform: false,
                idp: true
            };
            app_sdk_1.LoginAppSdk.reportEventToCoreSDK(updatedAnalyticsEvent);
        }
        catch (e) {
            console.error('An error occurred while trying to report an event to the App SDK from UI', e);
        }
    };
    return LoginAppSDKManager;
}());
exports.LoginAppSDKManager = LoginAppSDKManager;
//# sourceMappingURL=common-analytics-manager.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@login/analytics/common-analytics-manager.js
// module id = 581
// module chunks = 8